import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Cúram 8.1`}</h2>
    <p>{`Cúram by Merative™ is a leading solution for supporting the end-to-end social program and care coordination service delivery process. Merative Social Program Management 8.1 includes key enhancements to help citizens, caseworkers, and developers.`}</p>
    <h3>{`Caseworker productivity`}</h3>
    <p>{`Caseworker productivity improvements aim to improve the efficiency of completing a task as well as improve the user experience. In 8.1.0.0, we have improved the use of dropdowns in modals across all tasks throughout SPM. The filtering mechanism in dropdowns has been enhanced to provide a combination of both ‘starts with’ and ‘contains’, making it easier and more intuitive for caseworkers to find and select the required value from the dropdown list.`}</p>
    <p>{`In 8.1.0.0, we continue to extend multilingual support, which provides efficiency gains for multilingual caseworkers. Displaying the user interface in the citizen’s language removes the cognitive load imposed on multilingual caseworkers so they do not need to translate and also promotes a good flow of communication with the citizen as the caseworker does not need to focus their attention on translation. In this release, multilingual support is now available for work queues, quick link names, organization structure and unit names, as well as position, job, and location names. Anywhere these are presented to a caseworker, they can be displayed in an alternative language once the caseworker selects to change the display of the UI to that alternative language.  `}</p>
    <h3>{`Developer productivity`}</h3>
    <p>{`Developers are supported in implementing authentication requirements in custom solutions through technical documentation that provides step-by-step guide on configuration and examples where appropriate. In this release, we have extended the documentation available to developers for the implementation of authentication requirements.`}</p>
    <p>{`New hookpoints have been added to key financial business processes. These facilitate the inclusion of custom requirements into these business processes in a compliant manner. Compliant implementation promotes easier future upgrades.  `}</p>
    <p>{`For more details about these features, see the `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/spm/SPM_WhatsNew_810.pdf"
      }}>{`What’s new in 8.1`}</a>{` and the `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/releasenotes/spm8100.pdf"
      }}>{`8.1 release notes`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      